import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const AlreadyProccessedIds = styled.div`
  display: flex;
  flex-direction: column;
`;
